export default __webpack_public_path__ + "static/seo-default-cebaa0eff1f278f00a55c7994e23b580.png";